import React, { useState, useEffect } from "react";

import classes from "./Menu.module.css";

import clinics from "../../../../images/svgs/appointments.svg";
import diagnostic from "../../../../images/svgs/diagnostic.svg";
import rehab from "../../../../images/svgs/rehab.svg";
import museum from "../../../../images/svgs/museum.svg";
import school from "../../../../images/svgs/school2.svg";
import medicine from "../../../../images/svgs/medicine.svg";

import { Link } from "react-router-dom";

const Menu = (props) => {
  return (
    <div className={classes.container}>
      {!props.small && <h2>Our Departments</h2>}
      <div className={classes.row}>
      <Link to="/clinics">
        <div className={classes.department}>
          {!props.small && <img src={clinics} alt={"Specialized clinics"} />}
          <h4>Specialized Clinics</h4>
        </div>
        </Link>
        <div className={classes.department}>
          {!props.small && <img src={diagnostic} alt={"Specialized clinics"} />}
          <h4>Diagnostic Services</h4>
        </div>
        <div className={classes.department}>
          {!props.small && <img src={rehab} alt={"Specialized clinics"} />}
          <h4>Rehabilitation services</h4>
        </div>
      </div>
      <div className={classes.row}>
        <div className={classes.department}>
          {!props.small && <img src={school} alt={"Specialized clinics"} />}
          <h4>LWAH School of Excellence</h4>
        </div>
        <div className={classes.department}>
          {!props.small && <img src={medicine} alt={"Specialized clinics"} />}
          <h4>Medicines and medical supplies</h4>
        </div>
        <div className={classes.department}>
          {!props.small && <img src={museum} alt={"Specialized clinics"} />}
          <h4>Exhibitions and handicrafts</h4>
        </div>
      </div>
    </div>
  );
};
export default Menu;
